import Vue from 'vue';
import accountService from './index';

const success = (context, response) => {
  context.loading = false;
  context.btnDisabled = false;
  context.closeModal('#configure-netatmo-modal');
  toastr.success(response.data.msg);
  accountService.fetchAccount(context);
};

const failed = (context, error) => {
  context.loading = false;
  context.btnDisabled = false;
  if (error.response && error.response.data && error.response.data.msg && typeof error.response.data.msg == "object") {
    for (var key in error.response.data.msg) {
      if (error.response.data.msg.hasOwnProperty(key)) {
        toastr.error(error.response.data.msg[key]);
      }
    }
  } else {
    toastr.error(context.$t('account.settings.user_services_section.netatmo_credentials_wrong'));
  }
};

export default (context, netatmo) => Vue.$http.post('/sync-netatmo-devices', netatmo).then((response) => {
  if (response && response.status === 200) {
    success(context, response);
  }
}).catch((error) => {
  if (error.response) {
    failed(context, error);
  }
});



// WEBPACK FOOTER //
// ./src/app/services/account/syncDevices.js